var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.pickupTitle))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.pickupDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }